import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { initTheme } from './lib/theme'
import './index.css'

// Theme so früh wie möglich anwenden — verhindert Flash beim ersten Paint.
initTheme()

// ── Cross-Tab-Auth-Sync ────────────────────────────────────────────────────
//   Wenn der User in einem anderen Tab den Account wechselt (login/logout),
//   würde dieser Tab noch mit dem alten User-State weiterlaufen — sieht
//   andere Daten, aber API-Calls gehen mit dem neuen Token raus. Das ist
//   exakt der Auslöser des „User A steuert User B's Stempeluhr"-Bugs.
//   Lösung: storage-event abonnieren — wenn unser Auth-Token in einem
//   anderen Tab geändert wird, lädt dieser Tab neu.
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'custosoft.auth.token' && e.newValue !== e.oldValue) {
      // Hard reload — am sichersten. Garantiert dass kein Stale-State
      // (Hooks, modulweite Caches, React-State) übrig bleibt.
      window.location.reload()
    }
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
